<template>
    <main-layout>
        <div class="container">
            <H1 class="pageTitle isPoppins">Order History</H1>
           
            <div id="checkoutTableDiv" class="top40 accSettingsForm">
                <table width="100%" class="bottom10">
                    <tr class="top10 has-text-weight-bold" v-show="orders.length" >
                        <td width="10%" class="has-text-warning">Date</td>
                        <td width="80%" class="has-text-centered has-text-warning">Invoice ID</td>
                        <td width="20%" class="has-text-right has-text-warning">Amount</td>
                    </tr>

                    <tr v-for="(order, index) in this.orders" :key="order.id" :class="{'tableDarkRow': (index + 1) % 2}" class="ordersRow" @click="doDetail(order.itemId)">
                        <td>{{az.dateConvert(order.createDate)}}</td>
                        <td class="has-text-centered">{{order.shortId}}</td>
                        <td class="has-text-right">${{az.formatCurrency(order.price)}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import { AZEventBus } from '../components/AZEventBus'

export default {
  data: function () {
    var orders = []
    return {
      orders,
      az: az,
      inited: false
    }
  },
  components: {
    MainLayout
  },
  methods: {
    doDetail: function (id) {
      this.$router.push({name: "orderdetails",  params: {id: id}})
    }
  },
  mounted: function () {
    const self = this

    az.addRemSpinner(true, 'id', 'checkoutTableDiv');

    self.worked = function (data) {
      az.addRemSpinner(false, 'id', 'checkoutTableDiv');
      data.Items.forEach(e => {
        e.t = new Date(e.createDate).getTime() / 1000
      })
      data.Items.sort(function(a, b){
        return b.t - a.t
      })
      self.orders = data.Items

    }
    self.noWorked = function () {
      az.addRemSpinner(false, 'id', 'checkoutTableDiv');
      self.$root.showModalOK({message: 'There was en error loading orders. Pease try again.'})
    }

    function init(){
        self.inited = true
        var cartID = az.getCookie('SlinkCartID');
        self.$root.apiClient.get('api/account/orders', {}, self.worked, self.noWorked);
    }

    if(self.$root.doneFederating){
      init();
    }

    AZEventBus.$once('onFederate', msg => {
      if(self.inited == false)
            init();
    });
  
  }
}
</script>

<style scoped>
  #checkoutTableDiv{
    min-height: 300px;
  }

  table tr{
    line-height: 3rem;
  }

  table tr td{
    padding-left: 2px;
    padding-right: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Orders.vue